import { createSelector } from 'reselect'
import { ICampPlayerData } from '../../../helpers/data/campPlayer'
import { IPlayerData } from '../../../helpers/data/player'
import { ICharacterData } from '../../../helpers/data/characterData'
import viewTypes from '../../../helpers/enums/views'
import hiddenNameText from '../../../helpers/enums/hiddenNameText'
import userIdSelector from '../app/userIdSelector'
import charactersSelector from '../app/charactersSelector'
import hideStudentNamesSelector from '../app/hideStudentNamesSelector'
import skinSelector from '../app/skinSelector'
import { IStore } from '../../reducers/index'
import settings from '../../../helpers/enums/settings'

const playersSelector = (state: IStore) => {
	const players = state.game.participants
	const characters = charactersSelector(state)
	const shouldHideStudentNames = hideStudentNamesSelector(state)
	const playerUID = userIdSelector(state)

	const campPlayers = players
		.filter((player: IPlayerData) => player.view.type === viewTypes.CAMP)
		.map((player: IPlayerData): ICampPlayerData => {
			return {
				avatarId: player.avatar,
				avatarAsset: (characters.find((character: ICharacterData) => character.id === player.avatar) || characters[0])
					.camp,
				nickname: shouldHideStudentNames && player.deviceUid !== playerUID ? hiddenNameText : player.nickname,
				playerUID: player.deviceUid,
				order: player.order,
			}
		})

	return campPlayers
}

const teacherSelector = (state: IStore) => {
	return state.app.isTeacher
}

const gameSettingsSelector = (state: IStore) => {
	return state.game.settings
}

const animationsToggleSelector = (state: IStore) => state.app.animationsToggle

export default createSelector(
	playersSelector,
	teacherSelector,
	userIdSelector,
	skinSelector,
	gameSettingsSelector,
	animationsToggleSelector,
	(players, isTeacher, playerUID, skin, gameSettings, animationsToggle) => {
		const areAnimationsEnabledSetting = gameSettings.find((setting) => setting.id === settings.SETTING_TYPE_ANIMATIONS)

		const areAnimationsEnabled = animationsToggle.hasBeenToggled
			? animationsToggle.enabled
			: areAnimationsEnabledSetting
				? areAnimationsEnabledSetting.value === settings.SETTING_ANIMATIONS_ENABLED
				: true

		return {
			players,
			isTeacher,
			playerUID,
			skin: skin.waiting,
			areAnimationsEnabled,
		}
	}
)
